import { useSelector } from 'react-redux'

import { selectCurrentContactId } from 'ducks/crm/contacts'
import { useActionEffect } from 'util/hooks'

import { doFetchRecentConversations } from './operations'
import {
  selectIsOrWillBeLoadingRecentConversationsForCurrentCustomer,
  selectRecentConversationsForCurrentCustomer,
} from './selectors'

export function useRecentConversations() {
  const contactId = useSelector(selectCurrentContactId)
  useActionEffect(
    () => {
      if (contactId) doFetchRecentConversations(contactId)
    },
    [contactId]
  )

  const conversations = useSelector(selectRecentConversationsForCurrentCustomer)
  return {
    isLoading: useSelector(
      selectIsOrWillBeLoadingRecentConversationsForCurrentCustomer
    ),
    hasConversations: conversations?.length > 0,
    conversations,
  }
}
